<template>
 <div class="welcome">

    <div class="">

      <div class="client-background">
        
        <img class="client-logo" src="@/img/branding/Potteries-Heavy-Haulage-Logo-White.png" alt="Potteries Heavy Haulage Logo">

        <img class="client-image" src="@/img/PHH.png" alt="Potteries Heavy Haulage Vehicle">

        <div class="client-text">
          <h2>
            New Website Coming Soon
          </h2>
          <a class="client-phone" href="tel:01782827373">
            Call Us</a>       
        </div>   

           
      </div>

           
    </div>    
  </div>
</template>


<script>
export default {
    mounted(){

    }
}
</script>


<style lang="scss">

</style>